import PropTypes from 'prop-types';
import {
  awardPointsToggleSchema,
  hasDisplayDateToggleSchema,
  joinPerfectStoreToggleSchema
} from '../PerfectStoreSetUp/schemas';
import ReviewField from './ReviewField';

const toYesNo = (value) => (value ? 'Yes' : 'No');

const PerfectStoreSetupReview = ({formData = {}}) => {
  const fileName = formData?.targetMediaFile?.[0];

  return (
    <div
      className='flex flex-col gap-6'
      data-testid='perfect-store-setup-review'>
      <hr className='border-[color:var(--color-border-divider)]' />
      <div className='ml-4'>
        <p className='review-section-label mb-3'>Perfect Store Setup</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <div className='flex flex-row flex-wrap gap-6'>
          <ReviewField label='Target Type' value={formData?.targetType} />
          <ReviewField label='Name' value={formData?.name} />
        </div>
      </div>

      <>
        <div className='ml-4'>
          <p className='review-section-label mb-3'>Store Target</p>
          <hr className='mb-2 border-[color:var(--color-border-divider)]' />
          <div>
            <div className='review_subtitle'>File</div>
            {formData?.storeTargetFileUrl ? (
              <a
                className='review-file-link'
                href={formData.storeTargetFileUrl}
                target='_blank'
                rel='noreferrer'>
                {fileName}
              </a>
            ) : (
              <span className='review_title'>{fileName}</span>
            )}
          </div>
        </div>
      </>

      <div className='ml-4'>
        <p className='review-section-label mb-3'>Availability</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <div className='flex flex-row flex-wrap gap-6'>
          <ReviewField
            label='Active Start Date'
            value={formData?.activeStartDate}
          />
          <ReviewField
            label='Active End Date'
            value={formData?.activeEndDate}
          />
          {!formData?.awardPointsWhenTargetMet && (
            <ReviewField label='Reward Date' value={formData?.rewardDate} />
          )}
        </div>
        {formData?.hasDisplayDate && (
          <div className='mt-4 flex flex-row flex-wrap gap-6'>
            <ReviewField
              label='Display Start Date'
              value={formData?.displayStartDate}
            />
            <ReviewField
              label='Display End Date'
              value={formData?.displayEndDate}
            />
            <div className={`min-w-[140px] flex-1`.trim()}></div>
          </div>
        )}
        <div className='mt-4 flex flex-row flex-wrap gap-6'>
          <ReviewField
            label={hasDisplayDateToggleSchema.label}
            value={toYesNo(!formData?.hasDisplayDate)}
          />
          <ReviewField
            label={awardPointsToggleSchema.label}
            value={toYesNo(formData?.awardPointsWhenTargetMet)}
          />
          <div className={`min-w-[140px] flex-1`.trim()}></div>
        </div>
      </div>
      <div className='ml-4'>
        <p className='review-section-label mb-3'>Additional Options</p>
        <hr className='mb-2 border-[color:var(--color-border-divider)]' />
        <ReviewField
          label={joinPerfectStoreToggleSchema.label}
          value={toYesNo(formData?.requiredUserToJoin)}
        />
      </div>
    </div>
  );
};

PerfectStoreSetupReview.propTypes = {
  formData: PropTypes.object
};

export default PerfectStoreSetupReview;
